// vim: set ts=2 sw=2 et ft=javascript:
/*
 * Copyright (C) 2010, 2011 Minted LLC
 *
 * All Rights Reserved
 *
 * Javascript for product details page
 */
/*
  UMD header generated via modularize.js at 2015-04-02T17:19:27.302Z
  unresolved dependencies: _gaq, PAPER_OPTION_LABELS, defaultFormatId
  self-referred dependencies: getSelectedAltGreeting
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:constants': [],
  'minted:model/product_details/constants': [],
  'minted:view/product_details/constants': []
})(this, function (m_module, $, _) {
  var M = m_module.M;

  M.ProductDetails = M.ProductDetails || {};

  function trackSocial(network) {
    _gaq.push(['_trackSocial',
      M.GA.TRACK_SOCIAL_NETWORK_PREFIX.PDP + network,
      'Share']);
    return false;
  }

  function updateActiveState(source) {
    $('.activeLink').removeClass('activeLink');
    $(source).addClass('activeLink');
  }

  function swapImage(replacement, source){
    $('#zoomImage').attr({'src' : replacement });
      //updateActiveState(source); // TODO - need to fix the active state for zoom images
  }

  function shortenPaperDesc() {
    if ($('#paper-selection.choices .paperDesc').length > 0) {
      $('#paper-selection.choices .paperDesc').jTruncate({
        length: 15,
        minTrail: 0
      });
    }
  }

  getSelectedAltGreeting = function() {
    var $selection = $('.greetingPicker').
      find('.altGreeting').
      filter('.active');
    return $selection;
  }

  M.ProductDetails.displayInvalidOptionDialog = function(formatChoice, paperChoice, opts) {
    var title = "";

    var formatName = M.Model.ProductDetails.FORMAT_OPTION_LABELS[formatChoice];
    var formatAlternativeName = "";
    var formatAlternativeId = null;

    var paperName = PAPER_OPTION_LABELS[paperChoice];
    var paperAlternativeName = "";
    var paperAlternativesString = "";
    var paperAlternativeId = null;
    var defaultPaperId = null;

    // dictionary mapping available formats to corresponding available paper types
    var availablePaperFormatPairs = opts.availablePaperFormatPairs || null;
    // true if arrays mapped to above are mutually exclusive
    var paperSetsAreExclusive = opts.paperSetsAreExclusive || null;
    // true if dialog triggered by paper option selected, false by format option selected
    var paperOptionChanged = opts.paperOptionChanged || null;

    title = formatName + 's are not available in ' + paperName;

    _.each(availablePaperFormatPairs, function(paperIdArray, formatId) {
      // build string listing alternative paper options
      if (formatChoice == formatId) {
        for (var i=0; i<paperIdArray.length; i++) {
          var dfltName = M.Model.ProductDetails.PAPER_OPTION_LABELS[paperIdArray[i]];
          if (dfltName.indexOf("NEW") >= 0) {
            paperAlternativesString += PAPER_OPTION_LABELS[paperIdArray[i]];
          } else {
            paperAlternativesString += dfltName;
          }
          if (i == paperIdArray.length-2) {
            if (paperIdArray.length == 2) {
              paperAlternativesString += " and "
            } else {
              paperAlternativesString += ", and ";
            }
          } else if (i < paperIdArray.length-2) {
            paperAlternativesString += ", ";
          }
        }
      }

      // determine paper/format params for change button
      // case: user is trying to change paper type
      if (paperOptionChanged && !(formatChoice == formatId)) {
        // choose the first alternate format
        if (formatAlternativeId == null) {
          formatAlternativeId = formatId;
          formatAlternativeName = M.Model.ProductDetails.FORMAT_OPTION_LABELS[formatAlternativeId];

          paperAlternativeId = paperChoice;
          paperAlternativeName = PAPER_OPTION_LABELS[paperAlternativeId];

          defaultPaperId = paperIdArray[0];
          defaultFormatId = formatAlternativeId;
        }
        // case: user is trying to change format type
      } else if (!paperOptionChanged && formatChoice == formatId) {
        formatAlternativeId = formatChoice;
        formatAlternativeName = M.Model.ProductDetails.FORMAT_OPTION_LABELS[formatAlternativeId];

        paperAlternativeId = paperIdArray[0];
        _.each(paperIdArray, function(pid, index) {
          if (pid === M.Model.ProductDetails.SIGNATURE.toString()) {
            paperAlternativeId = M.Model.ProductDetails.SIGNATURE;
          } else if (pid === M.Model.ProductDetails.DOUBLE_THICK.toString() &&
                      paperAlternativeId !== M.Model.ProductDetails.SIGNATURE) {
            paperAlternativeId = M.Model.ProductDetails.DOUBLE_THICK;
          }
        });
        paperAlternativeName = PAPER_OPTION_LABELS[paperAlternativeId];

        defaultPaperId = paperAlternativeId;
        defaultFormatId = formatAlternativeId;
      }
    });

    // reflected values in generated html
    $('#invalidOptionDialog .formatName').html(formatName);
    $('#invalidOptionDialog .formatAlternativeName').html(formatAlternativeName);
    $('#invalidOptionDialog .paperName').html(paperName);
    $('#invalidOptionDialog .paperAlternativeName').html(paperAlternativeName);
    $('#invalidOptionDialog .paperAlternativesString').html(paperAlternativesString);

    $('#invalidOptionDialog .ok').hide();
    $('#invalidOptionDialog .change, #invalidOptionDialog .cancel').show();

    // configure dialog box
    $('#invalidOptionDialog').dialog({
      title: title,
      draggable: false,
      width: 470,
      closeOnEscape: false,
      modal: true,
      open: function(event, ui) { $(".ui-dialog-titlebar-close").hide(); }
    });

    $('#invalidOptionDialog').find('p.cancel a.button').click(function() {
      M.ProductDetails.hideInvalidOptionDialog();
    });
    $('#invalidOptionDialog').find('p.ok a.button').click(function() {
      M.ProductDetails.hideInvalidOptionDialog();
    });

    var changeButton = $('#invalidOptionDialog .change .button');
    changeButton.unbind('click');
    changeButton.click(function() {
      M.ProductDetails.hideInvalidOptionDialog();
      if (paperSetsAreExclusive) {
          opts.forceSet(formatAlternativeId, paperAlternativeId, defaultFormatId, defaultPaperId);
      } else {
        if (paperOptionChanged) {
          opts.setFormatFirst(formatAlternativeId, paperAlternativeId);
        } else {
          opts.setPaperFirst(formatAlternativeId, paperAlternativeId);
        }
      }
    });
  };

  M.ProductDetails.hideInvalidOptionDialog = function() {
    $('#invalidOptionDialog').dialog('close');
  };

  /**
   * Return the internal_name of the alternate greeting that was selected,
   * or undefined if not applicable.
   * (i.e. Holiday, Christmas, New Year)
   */
  M.ProductDetails.getSelectedAltGreetingName = function() {
    var $selection = getSelectedAltGreeting();
    if ($selection.length > 0) {
      return $selection.data('greeting-name');
    }
  };

  /**
   * Return the id of the alternate greeting that was selected,
   * or undefined if not applicable.
   * (i.e. 1, 2, 3)
   */
  M.ProductDetails.getSelectedAltGreetingId = function() {
    var $selection = getSelectedAltGreeting();
    if ($selection.length > 0) {
      return $selection.data('greeting-id');
    }
  };

  /**
   * Return the index alternate greeting that was selected,
   * or undefined if not applicable.
   * (i.e. 0, 1, 2)
   */
  M.ProductDetails.getSelectedAltGreetingIndex = function() {
    var $selection = getSelectedAltGreeting();
    if ($selection.length > 0) {
      return $selection.data('greeting-index');
    }
  };

  /**
   * Returns the die cut code of the selected image in the PDP.
   * (i.e. 'A', 'B', 'C')
   */
  M.ProductDetails.getSelectedDieCutCode = function() {
    var $selection = $('#productDetails').
      find('.dieCutSmallIcon').
      filter('.selected');

    if ($selection.length > 0) {
      return $selection.data('diecut-code');
    }
  };

  /**
   * Returns the color choice id of the selected image in the PDP.
   * (i.e. 11134, 11134)
   */
  M.ProductDetails.getSelectedColorChoiceId = function() {
    var $selection = parent.$('.altView').
      filter('.color').
      filter('.swatch').
      filter('.selected');

    if ($selection.length > 0) {
      return $selection.data('color-choice-id');
    }
  };

  /**
   * Returns the color choice code of the selected image in the PDP.
   * (i.e 'A', 'B', 'C')
   */
  M.ProductDetails.getSelectedColorCode = function() {
    var $selection = parent.$('.altView').
      filter('.color').
      filter('.swatch').
      filter('.selected');

    if ($selection.length > 0) {
      return $selection.data('color-code');
    }
  };

  /**
   * Opens the Viral Logo Description Dialog.
   *
   * This function is also called from the python product options panel
   * iframe to let the parent window know to display the dialog.
   */
  M.ProductDetails.openLogoDescriptionDialog = function(opts) {
    "use strict";
    opts.gaPageCategory = M.GA.TRACK_EVENT_CATEGORY.PDP;
    var logoDialog = new M.View.WeddingVirality.LogoDescriptionDialog(opts);
    logoDialog.render();
    logoDialog.bind('force_logo', function() {
      $('body').trigger('force_logo');
    });
    logoDialog.bind('optout_logo', function() {
      $('body').trigger('optout_logo');
    });
  };

  /**
   * Brings up a dialog if there is a shape and non flat paper choice selected.
   *
   *  'accept' on the dialog or if there is no shape selected.
   */
  M.ProductDetails.displayDieCutIncompatWarningDialog = function(opts) {
    var isThickPaperSelected = opts.isThickPaperSelected;
    var isFoldedFormatSelected = opts.isFoldedFormatSelected;
    var paperName = opts.paperName;

    var dieCutIncompatWarningDialog =
      new  M.View.ProductDetails.DieCutIncompatWarningDialog({
        paperName: paperName,
        isThickPaperSelected: isThickPaperSelected,
        isFoldedFormatSelected: isFoldedFormatSelected
      }).render();

    dieCutIncompatWarningDialog.bind('accept', function() {
      opts.acceptFunction();
    });
  };

  // Display proof messaging dialog when the user clicks on the proof links
  M.ProductDetails.openDefaultProofDialog = function(proofCreationDays) {
    var proofDialogModel = new M.Model.InfoDialog({
      title: 'one free proof with every order',
      body: M.Template.ProductDetails.DefaultProofMessage({
        proofingSLA: proofCreationDays
      })
    });
    var proofDialog = new M.View.InfoDialog({
      model: proofDialogModel,
      className: 'proofingDialog'
    });
    proofDialog.render();
  };

  M.ProductDetails.openWeddingProofDialog = function(proofCreationDays) {
    var proofDialogModel = new M.Model.InfoDialog({
      title: 'complimentary digital proofs with every order',
      body: M.Template.ProductDetails.WeddingProofMessage({
        proofingSLA: proofCreationDays
      })
    });
    var proofDialog = new M.View.InfoDialog({
      model: proofDialogModel,
      className: 'proofingDialog'
    });
    proofDialog.render();
  };

  M.ProductDetails.openNoProofDialog = function() {
    var proofDialogModel = new M.Model.InfoDialog({
      title: 'order policy',
      body: M.Template.ProductDetails.NoProofMessage
    });
    var proofDialog = new M.View.InfoDialog({
      model: proofDialogModel,
      className: 'proofingDialog'
    });
    proofDialog.render();
  };

  M.ProductDetails.openChangeToGrommetNotebook = function(formatName) {
    var dialog = new M.View.ProductDetails.InvalidCombinationDialog({
      title: formatName + ' Not Available with Grommet Binding',
      message: 'Our ' + formatName + 's are only available with spiral binding.' +
        ' If you\'d like grommet binding, you can choose from a blank, ' +
        'lined or grid interior notebook.',
      switchMessage: 'switch to grommet-bound notebook',
      keepMessage: 'keep spiral binding'
    }).render();

    dialog.bind('keepClicked', function() {
      $('body').trigger('changeBinding', [M.BindingOptions.SPIRAL]);
    })

    dialog.bind('switchClicked', function() {
      $('body').trigger('changeFormat', [M.FormatOptions.BLANK_NOTEBOOK]);
      $('body').trigger('changeBinding', [M.BindingOptions.GROMMETED]);
    })
  };

  M.ProductDetails.getViewOptionsForJournal = function(format) {
    var codeToLabels = {
      '001': 'Front',
      '002': 'Interior Options',
      '003': 'Interior',
      '004': 'Close-Up',
      '005': 'Back',
      '006': 'Stickers',
      '008': 'Wrap',
      '009': 'Interior Details'
    };

    var isMarketplace = M.SKU.isMarketplace(this.sku);
    var views = [];

    if (format === M.FormatOptions.BLANK_NOTEBOOK ||  format === M.FormatOptions.LINED_NOTEBOOK ) {
      views.push('001E');
      if (!isMarketplace) {
        views.push('008E');
      }
      views.push('002E');
      if (isMarketplace) {
        views.push('005E');
      }
      views.push('004');
    } else if (format == M.FormatOptions.MONTHLY_PLANNER_NOTEBOOK) {
      views.push('001F');
      views.push('002F');
      views.push('003F');
      views.push('006');
      views.push('009F');
      if (isMarketplace) {
        views.push('005F');
      }
      views.push('004');
    } else if (format == M.FormatOptions.WEEKLY_PLANNER_NOTEBOOK) {
      views.push('001G');
      views.push('002G');
      views.push('003G');
      views.push('006');
      views.push('009G');
      if (isMarketplace) {
        views.push('005G');
      }
      views.push('004');
    } else if (format == M.FormatOptions.ADDRESS_BOOK_NOTEBOOK) {
      views.push('001H');
      views.push('002H');
      views.push('003H');
      views.push('009H');
      if (isMarketplace) {
        views.push('005H');
      }
      views.push('004');
    }

    return _(views).map(function (viewCode) {
      var label = codeToLabels[viewCode.substring(0, 3)];
      return {
        id: 'view-code-' + viewCode,
        description: label,
        file_photo_code: viewCode
      };
    });
  };

  M.ProductDetails.trackBottomTab = function(tabName){
    M.sendTrackAPI({
      feature: M.GA.TRACK_EVENT_CATEGORY.PDP,
      event: M.GA.TRACK_EVENT_ACTION.BOTTOM_MODULE_SWITCH_TAB,
      sku: M.productSku,
      tab: tabName
    });
  };

  M.ProductDetails.trackBottomMoreByArtist = function(designerId) {
    M.sendTrackAPI({
      feature: M.GA.TRACK_EVENT_CATEGORY.PDP,
      event: M.GA.TRACK_EVENT_ACTION.BOTTOM_MODULE_SHOP_MORE_BY_ARTIST,
      sku: M.productSku,
      designer_id: designerId
    });
  };

  M.ProductDetails.trackBottomMoreByArtistSkuClick = function(targetSku) {
    M.sendTrackAPI({
      feature: M.GA.TRACK_EVENT_CATEGORY.PDP,
      event: M.GA.TRACK_EVENT_ACTION.BOTTOM_MODULE_MORE_BY_ARTIST_SKU_CLICK,
      sku: M.productSku,
      destination_sku: targetSku
    });
  };

  M.ProductDetails.instrumentBottomPanel = function() {
    $('#tabPanelBox').delegate('a', 'click', function() {
      var $link = $(this);
      var linkText = $link.text();

      // Remove artist name from tab name 'More by <artist_name>'
      // to identify the type of tab
      if (linkText.indexOf('More by') !== -1) {
        linkText = 'More by';
      }

      var tabs = {
        'Ordering': 'ordering',
        'More by': 'more_by',
        'Design Comments': 'design_comments'
      };

      // Identify what type of link was clicked
      var isTab = !!tabs[linkText];
      var isMoreByArtistLink = linkText.indexOf('Shop more by') !== -1;
      // Is clicked link is a descendant of a DOM element with class '.item'?
      var isMoreByArtistSkuLink = !!$link.parents('.item').length;

      if (isTab) {
        M.ProductDetails.trackBottomTab(tabs[linkText]);
      }
      else if (isMoreByArtistLink) {
        var designerId = $link.parents('#moreProducts').data('designer_id');
        M.ProductDetails.trackBottomMoreByArtist(designerId);
      }
      else if (isMoreByArtistSkuLink) {
        var targetSku = $link.parents('.item').data('sku');
        M.ProductDetails.trackBottomMoreByArtistSkuClick(targetSku);
      }
    });
  };

  M.ProductDetails.trackRightPanel = function(creationTime) {
    M.MintedAnalytics.track({
      app: M.MintedAnalytics.enums.apps.OldPdp,
      component: M.MintedAnalytics.enums.components.RightSidebar,
      creationTime: creationTime
    });
  };

  return {
    'trackSocial': trackSocial,
    'updateActiveState': updateActiveState,
    'swapImage': swapImage,
    'shortenPaperDesc': shortenPaperDesc
  };

});
